'use client';
/** @jsxImportSource @emotion/react */

import type { ListItemSecondaryActionProps } from '@mui/material/ListItemSecondaryAction';

import MuiListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';

/**
 * @deprecated Please use `List` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export type { ListItemSecondaryActionProps };
/**
 * @deprecated Please use `List` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-list-migration--list-migration-guide Migration guide}
 */
export const ListItemSecondaryAction = MuiListItemSecondaryAction;
